// Extracted from web/components/ModelCanvas.tsx; behavior and declaration bodies preserved.
import { EntityCard } from "./EntityCard.js";
import { RelationshipEdge } from "./RelationshipEdge.js";
export const nodeTypes = { entity: EntityCard },
  edgeTypes = { relationship: RelationshipEdge };
